var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.006,
    viewBox: "0 0 16 16.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zoom-out",
    transform: "translate(-6.215 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12839",
    "data-name": "Group 12839",
    transform: "translate(6.215 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12745",
    "data-name": "Path 12745",
    d: "M16.577,16.369a5.081,5.081,0,1,0-7.186,0A5.081,5.081,0,0,0,16.577,16.369Zm1.2-8.384a6.776,6.776,0,0,1,.561,8.947c.014.011.025.023.039.036l3.593,3.593a.847.847,0,1,1-1.2,1.2l-3.593-3.593-.036-.038a6.775,6.775,0,1,1,.634-10.142Z",
    transform: "translate(-6.215 -6)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutWhite);
export default __webpack_public_path__ + "static/media/zoom-out-white.2157e60294cbbcf946d15d31072f57a0.svg";
export { ForwardRef as ReactComponent };